import { Box } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'

import Image from 'next/image'
import type React from 'react'

const PLACEHOLDER_IMAGE_SRC = '/images/placeholder-image.png'
const BLUR_DATA_URL =
  'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDABQODxIPDRQSEBIXFRQdHx4eHRoaHSQtJSEkMjU1LC0yMi4xODY6NT04Mj4yNzlCRkJHSU1RUV9aXWNkZGRkZGT/2wBDARUXFx4aHR4eHWRgOi5kZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGT/wAARCAAIAAoDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBEQCEAwEPwAB//9k='

type Props = {
  src?: string | null
  alt: string
  sizes: string
  sx?: SxProps<Theme>
}

export const MenuItemImage: React.FC<Props> = ({ src, alt, sizes, sx }) => (
  <Box
    sx={[
      {
        position: 'relative',
        width: '100%',
        height: '100%',
        borderRadius: 2,
        overflow: 'hidden',
        backgroundColor: 'grey.100',
      },
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}>
    <Image
      src={src || PLACEHOLDER_IMAGE_SRC}
      quality={75}
      alt={alt}
      fill
      style={{
        objectFit: 'cover',
      }}
      sizes={sizes}
      loading="lazy"
      placeholder="blur"
      blurDataURL={BLUR_DATA_URL}
    />
  </Box>
)
